import { IInventoryItemsQueryParamsForSale } from 'gen/ApiClient';

export const DefaultInventoryItemsQueryParamsForSale: IInventoryItemsQueryParamsForSale = {
	searchString: '',
	sortParams: { direction: 'desc', property: 'created' },
	pageParams: { index: 1, size: 10 },
	categories: [],
	subcategories: [],
	forProductCatalogId: undefined,
	forPatientId: undefined,
	isShowAll: false,
};
